function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "#FFAF20",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M47.075 4.325L16.227 17.411l-6.396-3.117a1.172 1.172 0 0 0-.964-.028L.847 17.62a1.104 1.104 0 0 0-.36 1.818L10.8 29.496l.148.121a1.17 1.17 0 0 0 1.088.126l14.779-5.767-5.965 15.513c-.366.951.654 1.847 1.585 1.392l9.167-4.47.158-.094c.15-.105.271-.244.355-.406l8.963-17.49 10.342-3.757c2.964-1.196 4.352-4.463 3.14-7.316C53.35 4.498 50 3.144 47.076 4.325zm5.369 3.88c.726 1.71-.106 3.67-1.862 4.38L39.856 16.48l-.194.092a1.129 1.129 0 0 0-.43.456l-8.996 17.547-6.217 3.03 5.852-15.214.053-.181c.173-.84-.689-1.586-1.552-1.25l-16.487 6.433-8.583-8.371 5.98-2.5 6.4 3.123c.303.148.658.157.969.025L47.97 6.382c1.736-.7 3.745.111 4.473 1.822z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.519 2.553c.21-.085.44-.107.66-.064l.215.063L37.65 8.695c.585.235.863.889.622 1.46a1.153 1.153 0 0 1-1.299.666l-.197-.06-14.82-5.968-5.474 2.213 12.887 5.203c.52.21.797.75.682 1.268l-.062.192a1.153 1.153 0 0 1-1.3.666l-.196-.06L13.049 8.04a1.106 1.106 0 0 1-.188-1.97l.188-.095 8.47-3.422z"
}));

var SvgTravelTransactionsIcon = function SvgTravelTransactionsIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 41,
    style: {
      background: "transparent"
    },
    viewBox: "0 0 55 41",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTravelTransactionsIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/travel_transactions_icon.9a647aed.svg";
export { ForwardRef as ReactComponent };